export enum CLOUD_SERVICES {
  GOOGLE_PHOTOS_PICKER = 'googlephotospicker',
  REMOTE = 'remote',
}
